import React from 'react';
import styles from '../../styles/formComponent/Content.module.scss';

const Content = ({ 
  children, 
  className = '',
  variant = 'default', // small, large, default
  color = 'default', // primary, secondary, muted, success, warning, error, default
  align = 'left', // left, center, right
  type = 'text', // text, infoBox, warningBox, errorBox, successBox, helper, description
  weight = 'normal', // normal, bold, semiBold
  spacing = 'normal', // normal, compact, noMargin
  ...props 
}) => {
  const contentClasses = [
    styles.content,
    variant !== 'default' && styles[variant],
    color !== 'default' && styles[color],
    align !== 'left' && styles[align],
    type !== 'text' && styles[type],
    weight !== 'normal' && styles[weight],
    spacing !== 'normal' && styles[spacing],
    className
  ].filter(Boolean).join(' ');

  return (
    <p className={contentClasses} {...props}>
      {children}
    </p>
  );
};

export default Content;
